import { supabase } from '../supabaseClient';

// Get current user
export const getCurrentUser = async () => {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
};

// PROBLEMS
export const fetchProblems = async () => {
  const { data, error } = await supabase
    .from('problems')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
};

export const createProblem = async (problemData) => {
  // Get logged-in user
  const { data: { user } } = await supabase.auth.getUser();

  // Prepare data with user ID
  const newProblemData = {
    ...problemData,
    created_by: user.id,  // Auto-fill with logged-in user
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  };

  // Insert - use destructuring and NO .single()!
  const { data, error } = await supabase
    .from('problems')
    .insert([newProblemData])
    .select();

  if (error) {
    console.error('Insert error:', error);
    throw error;
  }

  return data[0]; // Return first item from array
};

export const updateProblem = async (id, problemData) => {
  const updatedData = {
    ...problemData,
    updated_at: new Date().toISOString()
  };

  const { data, error } = await supabase
    .from('problems')
    .update(updatedData)
    .eq('id', id)
    .select();

  if (error) {
    console.error('Update error:', error);
    throw error;
  }

  return data[0]; // Return first item from array
};

export const deleteProblem = async (id) => {
  const { error } = await supabase
    .from('problems')
    .delete()
    .eq('id', id);

  if (error) {
    console.error('Delete error:', error);
    throw error;
  }

  // Return success indicator
  return { success: true };
};

// SOLUTIONS
// Create or update solutions for a problem
export const saveSolutions = async (problemId, solutions) => {
  console.log('Saving solutions for problem:', problemId);
  console.log('Solutions to save:', solutions);

  // Step 1: Delete ALL existing solutions for this problem
  const { error: deleteError } = await supabase
    .from('solutions')
    .delete()
    .eq('problem_id', problemId);

  if (deleteError) {
    console.error('Error deleting old solutions:', deleteError);
  } else {
    console.log('Old solutions deleted successfully');
  }

  // Step 2: Only insert if there are new solutions
  if (!solutions || solutions.length === 0) {
    console.log('No solutions to insert');
    return [];
  }

  // Step 3: Prepare and insert new solutions
  const solutionsData = solutions.map(sol => ({
    problem_id: problemId,
    description: sol.description || sol,
    is_chosen: sol.isChosen || sol.is_chosen || false,
    created_at: new Date().toISOString()
  }));

  console.log('Inserting solutions:', solutionsData);

  const { data, error } = await supabase
    .from('solutions')
    .insert(solutionsData)
    .select();

  if (error) {
    console.error('Error inserting solutions:', error);
    throw error;
  }

  console.log('Solutions inserted successfully:', data);
  return data;
};

// Fetch solutions for a problem
export const fetchSolutions = async (problemId) => {
  const { data, error } = await supabase
    .from('solutions')
    .select('*')
    .eq('problem_id', problemId)
    .order('created_at', { ascending: true });

  if (error) {
    console.error('Fetch solutions error:', error);
    throw error;
  }

  return data || [];
};

// DOCUMENTS
export const fetchDocuments = async () => {
  const { data, error } = await supabase
    .from('documents')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
};

export const uploadDocument = async (file, metadata) => {
  // Get logged-in user
  const { data: { user } } = await supabase.auth.getUser();
  const fileName = `${Date.now()}_${file.name}`;
  const filePath = `${user.id}/${fileName}`;

  // Upload file to Storage
  const { data: uploadData, error: uploadError } = await supabase.storage
    .from('documents')
    .upload(filePath, file);

  if (uploadError) {
    console.error('Upload error:', uploadError);
    throw uploadError;
  }

  // Get public URL
  const { data: { publicUrl } } = supabase.storage
    .from('documents')
    .getPublicUrl(filePath);

  // Save metadata to database - NO .single()!
  const { data, error } = await supabase
    .from('documents')
    .insert([{
      filename: file.name,
      file_type: file.type,
      file_size: file.size,
      file_path: filePath,
      file_url: publicUrl,
      category: metadata.category,
      description: metadata.description,
      created_by: user.id,
      created_at: new Date().toISOString()
    }])
    .select();

  if (error) {
    console.error('Insert error:', error);
    throw error;
  }

  return data[0]; // Return first item from array
};

export const downloadDocument = async (filePath, filename) => {
  const { data, error } = await supabase.storage
    .from('documents')
    .download(filePath);

  if (error) throw error;

  // Create download link
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const deleteDocument = async (id, filePath) => {
  // Delete from storage
  const { error: storageError } = await supabase.storage
    .from('documents')
    .remove([filePath]);

  if (storageError) {
    console.error('Storage delete error:', storageError);
    throw storageError;
  }

  // Delete from database
  const { error } = await supabase
    .from('documents')
    .delete()
    .eq('id', id);

  if (error) {
    console.error('Delete error:', error);
    throw error;
  }

  // Return success indicator
  return { success: true };
};
